import type { AxiosPromise } from 'axios';

import { hosts } from '@/app/config';
import { BaseClient } from '@/clients/BaseClient/BaseClient';

import type { TranslateMessageResponseDto } from './translate-message.types';

type TranslateMessageRequest = {
  message: string;
  language: string;
  subject?: string;
};

class TranslateMessageClient extends BaseClient {
  translateMessage = ({
    message,
    language,
    subject,
  }: TranslateMessageRequest): AxiosPromise<TranslateMessageResponseDto> =>
    this.request({
      url: `${hosts.campaignsApi}/candidates/history/translate_message/`,
      method: 'POST',
      data: {
        message,
        language,
        ...(subject && { subject }),
      },
    });
}

export const translateMessageClient = new TranslateMessageClient();
